import { CalculationSection } from '@features/glossary';
import { TextProps, TextPropsTextConfig } from '@features/powerpoint';
import { calculationEntry } from '../components/calculation-entry';

export const getCalculations = (
  calculationItems: CalculationSection['items'],
  pagination: { perPage: number; page: number }
): TextProps => {
  const { perPage, page } = pagination;
  const itemsOnPage = Object.values(calculationItems).slice(
    page * perPage,
    (page + 1) * perPage
  );

  return {
    text: itemsOnPage.flatMap((item): TextPropsTextConfig[] => {
      const { label, definition } = item;

      const calculation: TextPropsTextConfig[] =
        item.calculationType === 'simple'
          ? [{ text: item.calculation, options: { breakLine: true } }]
          : Object.values(item.calculationByType).map(
              (c): TextPropsTextConfig => ({
                text: c,
                options: { breakLine: true },
              })
            );

      return [
        ...calculationEntry({ label, definition }),
        ...calculation,
        ...(item.additionalCalculations ?? []).map(
          (calculation): TextPropsTextConfig => ({
            text: calculation,
            options: { breakLine: true },
          })
        ),
      ];
    }),
  };
};

export type SlideSection = {
  label: string;
  items: TextProps;
};
